<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <p>Emails:</p>
      <EmailsContainer :emails="emails" />
      <EmailForm class="mt-5" />
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex';
import EmailsContainer from "@/components/messages/email/EmailsContainer";
import EmailForm from "@/components/messages/email/EmailForm";

export default {
  name: "EmailTab",
  components: {
    EmailsContainer,
    EmailForm,
  },
  computed: {
    ...mapGetters({
      emails: "emails/emails"
    })
  }
};
</script>
